import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./components/App";
import "./errorHandler.js";
import "./index.css";
import { configureStore } from "./store";

const myStore = configureStore();

const rootElement = document.getElementById("root") as HTMLElement;
const root = createRoot(rootElement);

root.render(
  <Provider store={myStore}>
    <App />
  </Provider>
);

export default myStore;
